import React from 'react';

import styles from './Icon.module.less';

export default ({ className, app = {} }) => {
  const classNames = [styles.Icon, className].filter(o => o).join(' ');

  return (
    <div
      className={classNames}
      style={{ backgroundImage: `url("${app.logoFile || require('./icon.png')}")` }}
    >
      {app.androidType === '1' && (
        <img src={app.androidSmallIcon || require('./android.png')} alt="" />
      )}
    </div>
  );
};
